import { FileText, Loader2 } from "lucide-react";

export const ProjectAssets = ({ artifacts, resources, onLifecycleUpdate, lifecycleUpdating }) => {
  const allAssets = [...artifacts, ...resources];
  const lcColors = { draft: "bg-amber-50 text-amber-600 border-amber-200", in_review: "bg-blue-50 text-[#014d7d] border-blue-200", approved: "bg-emerald-50 text-emerald-600 border-emerald-200", published: "bg-purple-50 text-purple-600 border-purple-200" };
  const transitions = { draft: ["in_review"], in_review: ["approved", "draft"], approved: ["published", "draft"], published: [] };
  const transitionLabels = { in_review: "Submit for Review", approved: "Approve", published: "Publish", draft: "Send Back" };

  return (
    <div className="p-6 space-y-2" data-testid="assets-tab">
      {allAssets?.map(a => {
        const lc = a.lifecycle_status || a.status || "draft";
        const nextStatuses = transitions[lc] || [];
        return (
          <div key={a.id} className="flex items-center gap-3 bg-white border border-border/50 rounded-xl px-4 py-3" data-testid={`asset-row-${a.id}`}>
            <div className="w-8 h-8 rounded-lg bg-[#014d7d]/5 flex items-center justify-center shrink-0"><FileText className="w-4 h-4 text-[#014d7d]" /></div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-foreground truncate">{a.title || a.name}</p>
              <div className="flex items-center gap-2 mt-0.5 text-[10px] text-foreground/50">
                <span className="capitalize">{a.type || a.format || "Asset"}</span>
                {a.category && <span className="px-1.5 py-0.5 bg-foreground/[0.04] rounded">{a.category}</span>}
                {a.version && <span className="text-foreground/45">v{a.version}</span>}
              </div>
            </div>
            <span className={`text-[9px] font-bold px-2 py-0.5 rounded-md border ${lcColors[lc] || lcColors.draft}`} data-testid={`lifecycle-badge-${a.id}`}>
              {lc.replace("_", " ").toUpperCase()}
            </span>
            {nextStatuses.length > 0 && (
              <div className="flex items-center gap-1">
                {nextStatuses?.map(ns => (
                  <button key={ns} onClick={() => onLifecycleUpdate(a.id, ns)} disabled={lifecycleUpdating[a.id]}
                    className={`text-[10px] font-semibold px-2 py-1 rounded-lg border transition-colors ${ns === "draft" ? "border-foreground/15 text-foreground/40 hover:bg-foreground/5" : "border-[#014d7d]/20 text-[#014d7d] hover:bg-[#014d7d]/5"}`}
                    data-testid={`lifecycle-${ns}-${a.id}`}>
                    {lifecycleUpdating[a.id] ? <Loader2 className="w-3 h-3 animate-spin" /> : transitionLabels[ns] || ns}
                  </button>
                ))}
              </div>
            )}
            {a.created_at && <span className="text-[10px] text-foreground/45 shrink-0">{new Date(a.created_at).toLocaleDateString()}</span>}
          </div>
        );
      })}
      {allAssets.length === 0 && <p className="text-center text-foreground/45 py-8 text-sm">No assets generated yet. Start a conversation to create content.</p>}
    </div>
  );
};
